const state = () => ({
  project:null,
  projects:[],
  flows:0,
  suppliers:0,
});
const getters = {
  project(state){
    return state.project
  },
  projects(state){
    return state.projects
  },
  flows(state){
    return state.flows
  },
  suppliers(state){
    return state.suppliers
  },
};
const  mutations =  {
  SET_PROJECT(state,data){
    state.project = data
  },
  SET_PROJECTS(state,data){
    state.projects = data
  },
  SET_FLOWS(state,data){
    state.flows = data
  },
  SET_SUPPLIERS(state,data){
    state.suppliers = data
  },
};
const actions =  {
  setProject({commit},data)  {
    commit("SET_PROJECT",data)
  },
  setProjects({commit},data)  {
    commit("SET_PROJECTS",data)
  },
  setFlows({commit},data)  {
    commit("SET_FLOWS",data)
  },
  setSuppliers({commit},data)  {
    commit("SET_SUPPLIERS",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

